import { Injectable, signal, computed } from '@angular/core';
import { environment } from '../../../environments/environment';

const STORAGE_KEY = 'dd_mock_mode';

@Injectable({
  providedIn: 'root'
})
export class MockToggleService {
  private mockEnabled = signal<boolean>(this.loadFromStorage());

  readonly isMockEnabled = computed(() => this.mockEnabled());

  toggle(): void {
    if (!environment.allowMockToggle) {
      this.disable();
      return;
    }

    const newValue = !this.mockEnabled();
    this.mockEnabled.set(newValue);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newValue));
  }

  enable(): void {
    if (!environment.allowMockToggle) {
      this.disable();
      return;
    }

    this.mockEnabled.set(true);
    localStorage.setItem(STORAGE_KEY, 'true');
  }

  disable(): void {
    this.mockEnabled.set(false);
    localStorage.setItem(STORAGE_KEY, 'false');
  }

  private loadFromStorage(): boolean {
    if (!environment.allowMockToggle) {
      return false;
    }

    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : true;
    } catch {
      return true;
    }
  }
}